export const EMPTY_ARRAY = Object.freeze([]) satisfies readonly unknown[]

/**
 * Represents an empty object and nothing else.
 * Because the type `{}` is unreliable in TypeScript and should not be used.
 *
 * @source https://github.com/sindresorhus/type-fest/blob/main/source/empty-object.d.ts
 */
export type EmptyObject = { [emptyObjectSymbol]?: never }
declare const emptyObjectSymbol: unique symbol
